import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import NoveltiesList from '../sections/Novelties/NoveltiesList';
import NoveltiesBanner from '../banners/Novalities-Banner/NoveltiesBanner';
import CustomDropdown from '../components/CustomDropdown';
import './NoveltiesFilters.css';
import Header from '../components/Header/Header';

const FILTERS = [
  { key: 'all', label: 'All Menu' },
  { key: 'specials', label: 'Kwality Special' },
  { key: 'milkshakes', label: 'Milkshakes' },
  { key: 'falooda', label: 'Falooda' },
  { key: 'sundaes', label: 'Sundaes' },
  { key: 'kulfi', label: 'Kulfi' },
  { key: 'cassata', label: 'Cassata' },
  { key: 'coffee', label: 'Coffee' },
  { key: 'fresh-juices', label: 'Fresh Juices' },
  { key: 'ice-cream-cakes', label: 'Ice Cream Cakes' },
  { key: 'bombay-gola', label: 'Bombay Gola' },
];

const Novelties = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const type = searchParams.get('type') || 'all';

  // Scroll behavior based on navigation source
  useEffect(() => {
    const hasTypeParam = searchParams.get('type');
    
    if (hasTypeParam) {
      // If coming from footer with specific section, scroll to heading
      const categoryTitle = document.getElementById('novelties-category-title');
      if (categoryTitle) {
        categoryTitle.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    } else {
      // If coming from navigation/other places, scroll to top
      window.scrollTo(0, 0);
    }
  }, [type, searchParams]);

  const handleFilterClick = (key) => {
    navigate(`/novelties?type=${key}`);
  };

  // Show custom dropdown only on mobile
  return (
    <>
      <Header />
      <NoveltiesBanner />
      <div className="novelties-filters-bar">
        {FILTERS.map((filter) => (
          <button
            key={filter.key}
            className={`novelties-filter-btn${type === filter.key ? ' active' : ''}`}
            onClick={() => handleFilterClick(filter.key)}
          >
            {filter.label}
          </button>
        ))}
      </div>
      <div className="custom-dropdown-mobile-wrapper">
        <CustomDropdown
          options={FILTERS}
          value={type}
          onChange={handleFilterClick}
        />
      </div>
      <NoveltiesList type={type} />
  
    </>
  );
};

export default Novelties; 